import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import {  PATIENT_API } from '../../ApiNames';


export const fetchData1 = (open: any) => ({
    type: 'FETCH_DATA1_SUCCESS',
    payload: open,
});
export const fetchData2 = (application: any) => ({
    type: 'FETCH_DATA6_SUCCESS',
    payload: application,
});




export const fetchHospitalData = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {};
            const apiname = PATIENT_API.gethosdata_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData1(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchApplication = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid};
            const apiname = PATIENT_API.aaapplication_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData2(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};



